// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatMessageLocation_wrapper__1kWfB"};